// extracted by mini-css-extract-plugin
export var emptyState = "_6y-d";
export var statCard = "_6y-c";
export var table = "_6y-0";
export var tableCell = "_6y-4";
export var tableCellClickable = "_6y-5 _6y-4";
export var tableCellDefault = "_6y-6 _6y-4";
export var tableCellEmpty = "_6y-8";
export var tableCellWithValue = "_6y-7";
export var tableContainer = "_6y-e";
export var tableHeaderWeight = "_6y-1";
export var tableHeaderZone = "_6y-2";
export var tableRowHeader = "_6y-3";
export var viewModeButton = "_6y-9";
export var viewModeButtonActive = "_6y-a _6y-9";
export var viewModeButtonInactive = "_6y-b _6y-9";